import type { ApolloLink } from "@apollo/client";

import { otelLink } from "./otelLink";
import { isOtelServerEnabled } from "./otelServerConfig";

/**
 * PGS-3525: the links that propagate trace context on the SSR Apollo clients.
 *
 * Empty unless server tracing is configured. With no provider of ours
 * registered, `propagation.inject` would fall through to the propagator
 * Sentry's default OpenTelemetry setup registered, which may add
 * `sentry-trace` and `baggage` headers to the API request. When tracing is
 * off the chain stays exactly as it was.
 */
export const getServerTraceLinks = (): ApolloLink[] =>
  isOtelServerEnabled() ? [otelLink] : [];
